import React, { Component } from 'react';
import echart from 'echarts';

class Board extends Component {
    componentDidMount() {
        this.echarts = echart.init(this.chartRef);
        this.setChart();
    }

    setChart = () => {
        const {
            mainInfo, data
        } = this.props;
        this.echarts.setOption({
            series: [
                {
                    name: mainInfo.name,
                    type: 'gauge',
                    radius: '100%',
                    min: 0,
                    max: data.key === 'wind_power' ? 17 : (data.value + (10 - data.value % 10)),
                    data: [
                        {
                            value: data.value,
                            name: `${data.name}(${data.unit})`
                        }
                    ],
                    radius: '100%',
                    axisLine: {
                        lineStyle: {
                            // color: [[0.2, '#228b22'],[0.8, '#48b'],[1, '#ff4500']],
                            color: [[1, '#02eeffaa']],
                            width: 6
                        }
                    },
                    axisTick: {
                        splitNumber: 5,
                        length :10,
                        lineStyle: {
                            color: 'auto'
                        }
                    },
                    splitLine: {
                        show: true,
                        length :15,
                        lineStyle: {
                            color: 'auto'
                        }
                    },
                    pointer : {
                        width : 5
                    },
                    startAngle: 200,
                    endAngle: -20,
                    title: {
                        // color: '#c8e1ea',
                        fontSize: 12,
                        color: '#ffffff',
                        offsetCenter: [0, '60%']
                    },
                    detail: {
                        fontSize: 20,
                        offsetCenter: [0, '35%']
                    }
                }
            ]
        });
    }

    render() {
        if (this.echarts) {
            this.setChart();
        }
        return (
            <canvas
                ref={e => this.chartRef = e}
            />
        );
    }
}

export default Board;